import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import { setUserProperties } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import type { WithLatestUpdateTimestamp } from '../types/index.tsx';
import {
	LOCAL_STORAGE_KEY_NAV_LOCATION,
	LOCAL_STORAGE_KEY_CATEGORY,
} from '../controllers/local-storage/index.tsx';

const MISSING_ACCOUNT_ID_ERROR_MSG = 'accountId is missing.';

export const updateQueueGroupsNavStateToUserProperty = <S extends WithLatestUpdateTimestamp>(
	navState: Record<string, S>,
	accountId?: AccountId | null,
): Promise<void> => {
	if (!accountId) {
		throw new Error(MISSING_ACCOUNT_ID_ERROR_MSG);
	}
	return setUserProperties(accountId, LOCAL_STORAGE_KEY_NAV_LOCATION, JSON.stringify(navState));
};

export const updateQueueCategoryState = <S extends WithLatestUpdateTimestamp>(
	categoryState: Record<string, S>,
	accountId?: AccountId | null,
): Promise<void> => {
	if (!accountId) {
		throw new Error(MISSING_ACCOUNT_ID_ERROR_MSG);
	}
	return setUserProperties(accountId, LOCAL_STORAGE_KEY_CATEGORY, JSON.stringify(categoryState));
};
